import React, { FC, useMemo } from 'react';
import styled from 'styled-components/native';

import { DEMO_LOGINS, ELoginAs, LIVE_LOGINS_WITHOUT_CRM } from '@webtrader/core/constants/account';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useCompany } from '@webtrader/core/services/company';
import { validateCompanyAccess } from '@webtrader/core/validators/company';

import AccountSignUp from './AccountSignUp';
import ExperienceDemo from './ExperienceDemo';
import ResetPasswordSignUpLink from './ResetPasswordLink';

interface IMiscItemProps {
  selectedTab: ELoginAs;
  registrationUrl?: string;
  setNeedUpdateFields?: (value: boolean) => void;
}

interface IRenderResetPasswordContentProps {
  selectedTab: ELoginAs;
  hasForgotPasswordAccess: boolean;
  hasResetPasswordAccess: boolean;
}

const renderResetPasswordContent = ({
  selectedTab,
  hasForgotPasswordAccess,
  hasResetPasswordAccess
}: IRenderResetPasswordContentProps) => {
  let content;

  if (LIVE_LOGINS_WITHOUT_CRM.includes(selectedTab)) {
    content = hasForgotPasswordAccess && <ResetPasswordSignUpLink />;
  } else if (selectedTab === ELoginAs.LIVE) {
    content = hasResetPasswordAccess && <ResetPasswordSignUpLink isLive={true} />;
  }

  return content;
};

const MiscItem: FC<IMiscItemProps> = (props) => {
  const { selectedTab, registrationUrl, setNeedUpdateFields } = props;
  const { company } = useCompany();
  const isOnDemoTab = DEMO_LOGINS.includes(selectedTab);

  const {
    hasResetPasswordAccess,
    hasExperienceAccess,
    hasForgotPasswordAccess,
    hasDemoAccountCreation
  } = useMemo(() => {
    return validateCompanyAccess(company);
  }, [company]);

  const showDivider = (isOnDemoTab && hasDemoAccountCreation) || !!registrationUrl;

  if (hasExperienceAccess) {
    return (
      <Misc>
        <ExperienceDemo setNeedUpdateFields={setNeedUpdateFields} />
      </Misc>
    );
  }

  return (
    <Misc>
      {renderResetPasswordContent({ selectedTab, hasForgotPasswordAccess, hasResetPasswordAccess })}
      {showDivider && <MiscDivider />}
      <AccountSignUp
        selectedTab={selectedTab}
        registrationUrl={registrationUrl}
        setNeedUpdateFields={setNeedUpdateFields}
      />
    </Misc>
  );
};

export default MiscItem;

const Misc = styled.View`
  padding-top: ${dynamicSize.convertSize(16)}px;
  padding-bottom: ${dynamicSize.convertSize(32)}px;
`;

const MiscDivider = styled.View`
  height: 1px;
  margin: ${dynamicSize.convertSize(16)}px 0;

  background-color: ${({ theme }) => theme.colors.border[0]};
`;
